<template>
  <button
    class="overlay"
    :class="{ overlay_transparent: isTransparent }"
    type="button"
    v-on="$listeners"
  >
    <slot>
      <span v-if="icon || label" class="overlay__inner">
        <BaseIcon
          v-if="icon"
          name="point"
          class="overlay__icon"
        />
        <BaseTitle
          v-if="text"
          :text="text"
          class="overlay__text"
          tag="b"
          is-center
          is-up
        />
      </span>
    </slot>
  </button>
</template>

<script>
import BaseIcon from '@/components/BaseIcon.vue';
import BaseTitle from '@/components/BaseTitle.vue';

export default {
  name: 'BaseOverlay',
  components: {
    BaseIcon,
    BaseTitle,
  },
  props: {
    icon: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    isTransparent: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="stylus">
.overlay
  display flex
  align-items center
  justify-content center
  width 100%
  height 100%
  background alpha($c_text, 90%)
  font-size 2.4em
  color #fff
  padding 0
  margin 0
  border 0
  outline none

  &_transparent
    background none

  &__icon
    width 3.2em
    height @width
    margin 0 auto 0.8em auto

  &__text
    display block
    max-width 12em
</style>
